import Toggle from '@components/Toggle/Toggle';
import { Box, IconPadlockLocked, IconPadlockUnlocked, Inline, Stack, Text } from '@ui-lib';

import * as styles from './LockToggle.css';

type LockToggleProps = {
  locked: boolean;
  lockedMessage?: string;
  unlockedMessage?: string;
  onToggle: (lock: boolean) => void;
};

export const LockToggle: React.FC<LockToggleProps> = ({
  locked,
  lockedMessage,
  unlockedMessage,
  onToggle,
}) => {
  return (
    <Inline gap="medium" className={styles.lockRow} alignY="center">
      <Box className={styles.lockIcon}>{locked ? <IconPadlockLocked /> : <IconPadlockUnlocked />}</Box>
      <Stack>
        <Text weight="demibold" className={styles.lockTitleText}>
          Lock edits
        </Text>

        {locked && lockedMessage && (
          <Text tone="neutral" size="small">
            {lockedMessage}
          </Text>
        )}
        {!locked && unlockedMessage && (
          <Text tone="neutral" size="small">
            {unlockedMessage}
          </Text>
        )}
      </Stack>
      <Box className={styles.toggleContainer}>
        <Toggle state={locked} onChange={onToggle}></Toggle>
      </Box>
    </Inline>
  );
};
